import { useEffect } from 'react';

import Layout from "../../hocs/layout/Layout";
import NavBar from "../../components/navigation/Navbar";
import Footer from "../../components/navigation/Footer";
import Nosotros from "../../components/about/Nosotros"
import Historia from "../../components/about/Historia";
import Empresa from "../../components/about/Empresa";


function About(){
    useEffect(() => {
            window.scrollTo(0,0)
        },[])
    return(
        <Layout>
            <NavBar/>
            <div>
                <Nosotros/>
                <Historia/>
                <Empresa/>
                
                {/* <Valores/> */}
            </div>
            <Footer/>
        </Layout>
    )
}export default About;